import axios from 'axios'
import { Message } from 'element-ui'

// 封装axios
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 30000, // request timeout
  paramsSerializer: function(params) {
    //序列化请求参数，避免get请求参数出现&,空格等识别错误的问题
    let result = ''
    Object.keys(params).forEach(key => {
      result += `${key}=${encodeURIComponent(params[key])}&`
    })
    return result.substr(0, result.length - 1)
  }
})

// 请求拦截器
service.interceptors.request.use(config => {
  if (sessionStorage.getItem('token')) {
    config.headers.token = sessionStorage.getItem('token')
  }
  return config
})

// 响应拦截器
service.interceptors.response.use(
  response => {
    response.data.status = response.status
    return response.data
  },
  error => {
    // 统一错误处理
    const { code, message } = error
    let msg = message
    // 请求超时等错误
    if (code) {
      switch (code) {
        case 'ECONNABORTED':
          msg = '请求超时!请更改条件后重试'
          break
        default:
          break
      }
    }
    // 后台返回错误代码
    if (error && error.response) {
      const { data } = error.response
      switch (error.response.status) {
        case 400:
          msg = data.msg ? data.msg : '请求错误(400)'
          break
        case 401:
        case 402:
        case 409:
          msg = '(' + error.response.status + ')'
          break
        case 403:
          msg = '拒绝访问(403)'
          break
        case 404:
          msg = '请求的资源不存在(404)'
          break
        case 408:
          msg = '请求超时(408)'
          break
        case 410:
          msg = data.msg ? data.msg : 'Token失效(410)'
          break
        case 500:
          msg = '服务器错误(500)'
          break
        case 501:
          msg = '服务未实现(501)'
          break
        case 502:
          msg = '网络错误(502)'
          break
        case 503:
          msg = '服务不可用(503)'
          break
        case 504:
          msg = '网络超时(504)'
          break
        case 505:
          msg = 'HTTP版本不受支持(505)'
          break
        default:
          msg = `连接出错(${error.response.status})!`
      }
    }
    // 显示错误提示
    Message.error({ message: msg })

    console.log('err' + error) // for debug

    return Promise.resolve(error)
  }
)

export default function request({ url, method, data = {} }) {
  // GET请求时将使用params传参
  const config = method.toUpperCase() === 'GET' ? { url, method, params: data } : { url, method, data }
  return service(config)
}



// WEBPACK FOOTER //
// ./src/api/request.js